import React from 'react';
import { Link } from 'react-router';
import { Upload } from 'lucide-react';

import Avatar from '~/components/Avatar';
import Loading from '~/components/Loading';
import ReactMarkdown from '~/components/Markdown';
import { FollowButton } from '~/components/ui/Button';
import { useTranslation } from '~/hooks/useTranslation';

import UserFeaturedImages from './UserFeaturedImages';

import styles from './GalleryPageHeader.scss';

export const GalleryPageHeader = ({
  user,
  currentUser,
  isSignedIn,
}: {
  user: User;
  currentUser: User | null;
  isSignedIn: boolean;
}) => {
  const { t } = useTranslation();

  if (!user) return <Loading />;

  return (
    <div className={styles.GalleryPageHeader}>
      <div className={styles.UserCard}>
        <Avatar
          className={styles.UserCard__Photo}
          userId={user.id}
          username={user.username}
          size="64"
        />
        <span className={styles.UserCard__Username}>{user.username}</span>
        <div className={styles.UserCard__FollowerCount}>
          {/* @ts-expect-error */}
          <b>{user.follower_count}</b>
          <span>{t('SocialFollowers_Subheading', 'Followers')}</span>
        </div>
        {user.stream && <FollowButton username={user.username} />}
        {isSignedIn && currentUser?.username === user.username ? (
          <Link to={`/gallery/upload`}>
            <button>
              {t('Gallery_UploadButton', 'Upload Media')}
              &nbsp;
              <Upload size={14} />
            </button>
          </Link>
        ) : (
          <Link to={`/watch/${user.username}`}>
            <button>
              {`${user.username}'s Stream`}{' '}
              {user.stream && user.stream.live && '[Live]'}
            </button>
          </Link>
        )}
        <div className={styles.UserCard__Description}>
          {/* @ts-expect-error */}
          <ReactMarkdown children={user.gallery?.profile_description} />
        </div>
      </div>

      <div className={styles.GalleryPageHeader__Featured}>
        <UserFeaturedImages username={user.username} />
      </div>
    </div>
  );
};

export default GalleryPageHeader;
